import { useMemo } from 'react';

import { seasonService } from '../../../../services';
import { createApiSlice } from '../../utils/createApiSlice';

const removeSeasonFieldDeviceSlice = createApiSlice({
  reducerPath: ['devices', 'seasonFieldDevices', 'removeSeasonFieldDevice'],
  apiFunction: seasonService.removeFieldDeviceV2
});

const { actions, useApiSelectors } = removeSeasonFieldDeviceSlice;

export const removeSeasonFieldDeviceActions = actions;

export const useRemoveSeasonFieldDeviceSelectors = () => {
  const { inProgress, success, errorMessage, response, updatedAt } =
    useApiSelectors();

  return useMemo(
    () => ({ inProgress, success, errorMessage, response, updatedAt }),
    [errorMessage, inProgress, response, success, updatedAt]
  );
};

export default removeSeasonFieldDeviceSlice;
